import React, {Component} from 'react'
import Base from '../BaseComponent'
import Entry from '../../models/Entry'

import Content from '../Content'

import moment from 'moment';

const today = moment().format('dddd').toLowerCase();// monday...sunday

class LifeAdvice extends Component {

	shouldComponentUpdate = () => {

		return false;
	}

	getDay = (lifeAdvice) => {

		let day = lifeAdvice.find((i) => {

			return (i.day.toLowerCase() == today)
		});

		return day;
	}



  render () {

    return (

    <Entry id={[2]} render={(entry) => (
      <Base family="Item" modifiers={['lifeAdvice']} >

        	<div className="Item-head">
            <Content modifier={'lifeAdvice'}>
              <h2>{this.getDay(entry.lifeAdvice).phrase}</h2>
            </Content>
        	</div>
        	<div className="Item-body">
            <Content modifier={'lifeAdvice'}>
              <h1>{this.getDay(entry.lifeAdvice).advice}</h1>
            </Content>
        	</div>

      </Base>
      )}/>
    )
  }
}

export default LifeAdvice



// WEBPACK FOOTER //
// ./src/js/components/LifeAdvice/LifeAdvice.jsx